{
  "fr": {
    "modal": {
      "actions": {
        "add": "Assigner le client à cette unité",
        "approve": "Approuver",
        "assign": "Assigner à cette unité",
        "assign_SUP": "Affecter à ce projet",
        "block": "Bloquer",
        "cancel": "Annuler",
        "close": "Fermer",
        "contact_ziggu": "Contacter Ziggu",
        "deactivate": "Deactiver",
        "giveAccess": "Donner un accès en ligne",
        "goBack": "Retourner",
        "gotIt": "D'accord",
        "loading": "En cours de chargement",
        "next": "Suivant",
        "no": "Non",
        "reactivate": "Réactiver",
        "remove": "Supprimer",
        "select_rights": "Sélectionnez les droits",
        "send": "Envoyer une invitation",
        "sendFeedback": "Envoyer un retour d'information",
        "skip": "Passer",
        "submit": "Enregistrer",
        "submitting": "Submitting",
        "uploading": "Télécharger",
        "yes": "Oui"
      },
      "labels": {
        "areYouSure": "Êtes-vous sûr?",
        "areYouSureDelete": "Êtes-vous sûr de vouloir supprimer {object}?",
        "assignCustomerToUnitMessagePermanently": "{customer} a déjà été invité à la plate-forme. En affectant cette unité, le client aura un accès immédiat.",
        "assignCustomerToUnitTitlePermanently": "Assigner {customer} de façon permanente à {unit}?",
        "assignTodoListToLevel": "Vous êtes sur le point d'affecter la liste d'objets {objet} au niveau {niveau}. Continuer?",
        "dangerZone": "Zone de danger",
        "deactivate": "Êtes-vous sûr de vouloir désactiver {contact}?",
        "deactivateMessage": "L'utilisateur se verra refuser l'accès à la plate-forme. Tous les documents, annonces et conversations lié à cette personne resteront accessibles sur la plateforme pour les autres utilisateurs.",
        "deleteCustomerMessage": "Cette personne perdra tout accès à la plate-forme et par conséquent tous les documents, FAQ, conversations, annonces, etc.",
        "deleteCustomerTitle": "Êtes-vous sûr de vouloir supprimer {customer}?",
        "deleteDecisionsBulk": "Êtes-vous sûr de vouloir supprimer {amount} décisions ?",
        "deleteDeniedMessage": "Ce client a au moins 1 unité qui lui est assignée. Supprimer toutes les unités attribuées avant de supprimer ce client.",
        "deleteDeniedTitle": "Supprimer non autorisé pour {customer}",
        "deleteEmployeeIntercom": "Contactez-nous via Intercom et nous vous aiderons immédiatement!",
        "deleteEmployeeMessage": "Cet utilisateur perd tout accès à la plate-forme. Tous les documents, conversations et annonces relatifs à cet utilisateur seront également supprimés.",
        "deleteEmployeeQuestion": "Plutôt supprimer?",
        "deleteEmployeeSubMessage": "Veuillez désactiver cet utilisateur à la place si vous souhaitez conserver toutes ses informations.",
        "deleteEmployeeTitle": "Êtes-vous sûr de vouloir supprimer {employee}?",
        "deleteLeadMessage": "Si ce prospect était intéressé par une unité, vous perdrez ces données. Si le prospect a acheté une unité et est devenu client, vous conserverez le client et ses données.",
        "deleteLeadTitle": "Voulez-vous vraiment supprimer le prospect {lead} ?",
        "goToProposal": "Aller à {proposal_name}",
        "gotItMessage": "Ok, j'ai compris",
        "loading": "Le fichier est en cours de téléchargement, veuillez patienter. L'écran de téléchargement se ferme automatiquement.",
        "noUnitSelected": "Oh oh ! Aucune unité sélectionnée",
        "noUnitSelectedMessage": "Sélectionnez l'unité sur laquelle vous souhaitez signaler un défaut",
        "notPossible": "Impossible",
        "ohNo": "Oh non !",
        "reactivate": "Êtes-vous sûr de vouloir réactiver {contact}?",
        "reactivateMessage": "L'utilisateur aura à nouveau accès à la plate-forme.",
        "removeCustomerDeleteInfo1": "Les conversations auxquelles le client a participé seront supprimées",
        "removeCustomerDeleteInfo2": "Les formulaires liées à cette unité seront supprimées",
        "removeCustomerDeleteInfo3": "Les documents téléchargés par le client dans le cadre de conversations, de décisions ou de propositions seront supprimés. Cela inclut également les versions signées des documents.",
        "removeCustomerKeepInformation": "Les documents généraux et tout autre contenu publié sur cet appareil resteront inchangés et seront visibles pour un nouveau client.",
        "removeCustomerMessage": "{customer} a eu un accès complet à cette unité. Si vous supprimez de client, tout contenu de {customer} sera supprimé. Cela signifie que…",
        "removeCustomerMessageNth": "Si vous supprimez ce client, le contenu créé par {customer} sera dissocié de {customer}. Cela signifie que le contenu sera conservé, mais ne proviendra plus de {customer}.",
        "removeMessage": "Êtes-vous sûr de vouloir supprimer {level}? En faisant cela, vous perdrez toutes vos données liées à ce {type}. Vous ne pourrez pas les récupérer.",
        "removeTitle": "Supprimer {record_name}",
        "revokeAccessMessage": "Vous êtes sur le point de révoquer l'accès de {customer} à cette unité. S'il s'agit de la seule unité attribuée, le client perdra l'accès complet à la plate-forme.",
        "setCustomerMessage": "Ceci est juste une reservation. {customer} n'aura pas encore un accès complet à {unit}. Vous pourrez inviter ce client {customer} après.",
        "setCustomerMessageSUP": "C'est très bien ! Vous êtes sur le point d'assigner {customer} à {unit}. {customer} n'aura pas encore un accès complet à la plate-forme. Mais vous pouvez changer cela en accordant l'accès une fois que vous avez assigné ce projet. ",
        "setCustomerTitle": "Assigner {unit} à {customer}?",
        "setVisibleMessage": "{customer} aura un accès complet à tous les documents partagés et aux informations partagées liées à cette unité.",
        "setVisibleTitle": "Donner à {customer} un accès en ligne à {unit}?",
        "this": "cette",
        "typeHere": "Tapez ici...",
        "typeToConfirm": "Tapez \"{confirmationInput}\" pour confirmer",
        "warningAreYouSure": "ATTENTION! Êtes-vous sûr?",
        "warningDeleteDocument": "{file_name} a été téléversé dans un {attachable_type}. Le supprimer ici le supprimera également de {attachable_type}",
        "warningDeleteDocumentApprovedProposal": "{file_name} est un document appartenant à une proposition approuvée et ne peut pas être supprimé dans cet état. La supprimer nécessiterait de revenir sur l'approbation de la proposition",
        "warningDeleteDocumentLevel": "{file_name} a été téléversé dans le dossier {level_type}. Le supprimer ici le supprimera également du dossier {level_type}",
        "warningDeleteDocumentMulti": "Certains des documents que vous souhaitez supprimer ont été téléchargés dans une décision ou une conversation. Les supprimer ici les supprimera également de la décision ou de la conversation"
      }
    }
  }
}
